import { render, staticRenderFns } from "./GStudentRecordFindingsProposals.vue?vue&type=template&id=18d5489c&scoped=true&"
import script from "./GStudentRecordFindingsProposals.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordFindingsProposals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d5489c",
  null
  
)

export default component.exports